import React, { useEffect, useRef, useState } from "react";
import bgImage from "../../Assets/bgimage.PNG";
import { Link } from "react-router-dom";
import './Footer.css'

export default function Footer() {
  const sectionsRef = useRef([]);
  const [inViewSections, setInViewSections] = useState([]);
  const [scrollDirection, setScrollDirection] = useState("down");
  const [lastScrollY, setLastScrollY] = useState(0);

const [email, setEmail] = useState("");
const [message, setMessage] = useState("");
const [copied, setCopied] = useState(false);

const handleCopy = () => {
  navigator.clipboard.writeText("+92 123456789");
  setCopied(true);

  // Hide message after 2 seconds
  setTimeout(() => setCopied(false), 2000);
};

const handleFooterEmailSubmit = async () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    setMessage("Please enter a valid email address.");
    return;
  }

  try {
    const response = await fetch("/api/contactfooter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (response.ok) {
      setMessage("Email sent successfully");
      setEmail(""); // Clear the input field
    } else {
      setMessage("Failed to subscribe. Please try again.");
    }
  } catch (error) {
    setMessage("An error occurred. Please try again.");
    console.error(error);
  }
};

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollDirection(currentScrollY > lastScrollY ? "down" : "up");
      setLastScrollY(currentScrollY);

      const newInViewSections = sectionsRef.current.map((section) => {
        if (section) {
          const rect = section.getBoundingClientRect();
          return rect.top <= window.innerHeight && rect.bottom >= 0;
        }
        return false;
      });
      setInViewSections(newInViewSections);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className="bg-black text-gray-400 py-10 relative overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Top Logo and Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center border-b border-gray-700 pb-6 mb-6">
        <div className="text-white text-xl font-bold mb-6 md:mb-0">KAYDEETECH</div>
        <div className="flex space-x-6">
          <a href="#facebook" className="hover:text-white">
            Facebook
          </a>
          <a href="#linkedin" className="hover:text-white">
            LinkedIn
          </a>
          <a href="#instagram" className="hover:text-white">
            Instagram
          </a>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Left Section */}
        <div
          ref={(el) => (sectionsRef.current[0] = el)}
          className={`parallax-content flex flex-col items-start space-y-4 ${
            inViewSections[0]
              ? scrollDirection === "down"
                ? "in-view-down"
                : "in-view-up"
              : ""
          }`}
        >
          <h3 className="text-white text-2xl font-bold">
            Have a project in mind?
          </h3>
          <h2 className="text-orange-600 text-3xl font-bold">Get Quotes</h2>
          <div>
            <a
              href="https://mail.google.com/mail/u/3/#inbox"
              className="block bg-gray-700 text-white py-2 px-4 rounded-md hover:bg-gray-600"
            >
              kayeetechofficial@gmail.com
            </a>
            <div className="relative">
      <p
        onClick={handleCopy}
        className="block bg-gray-700 text-white py-2 px-4 rounded-md mt-2 hover:bg-gray-600 cursor-pointer"
      >
        +92 123456789
      </p>
      {copied && (
        <span className="absolute top-12 text-white text-sm shadow-md">
          Number copied to clipboard!
        </span>
      )}
    </div>
          </div>
        </div>

        {/* Middle Section */}
        <div
          ref={(el) => (sectionsRef.current[1] = el)}
          className={`parallax-content flex flex-col space-y-2 ${
            inViewSections[1]
              ? scrollDirection === "down"
                ? "in-view-down"
                : "in-view-up"
              : ""
          }`}
        >
          <h4 className="text-white font-semibold text-lg">KAYDEETECH</h4>
          <ul className="space-y-2">
            <Link to={"/about"}>
              <li className="hover:text-white">About Us</li>
            </Link>
            <Link to={"/services"}>
              <li className="hover:text-white">Services</li>
            </Link>
          </ul>
        </div>

        {/* Right Section */}
        <div
          ref={(el) => (sectionsRef.current[2] = el)}
          className={`parallax-content flex flex-col space-y-4 ${
            inViewSections[2]
              ? scrollDirection === "down"
                ? "in-view-down"
                : "in-view-up"
              : ""
          }`}
        >
          <ul className="space-y-2">
            <Link to={"/contactus"}>
              <li className="hover:text-white">Contact</li>
            </Link>
            <Link to={"/terms-&-conditions"}>
              <li className="hover:text-white">Terms & Conditions</li>
            </Link>
            <Link to={"/privacy-policy"}>
              <li className="hover:text-white">Privacy Policy</li>
            </Link>
          </ul>
          <div className="flex relative w-full">
           <input
            type="email"
            placeholder="Type Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-gray-700 text-gray-300 rounded-md py-2 px-4 w-full focus:outline-none"
          />
          <button
            onClick={handleFooterEmailSubmit}
            className="absolute right-0 top-0 h-full px-4 bg-orange-500 text-white rounded-r-md hover:bg-orange-600"
          >
            →
          </button>
        </div>
        {message && <p className="text-white mt-2">{message}</p>}
      </div>
        </div>
    </div>
  );
}